import KeenSlider from 'keen-slider';
window.Slider = KeenSlider;
document.dispatchEvent(new CustomEvent("custom:keenLoaded", {
    detail: { slider: KeenSlider }
}));